import StaticOverlayTree from './StaticOverlayTree';

export default StaticOverlayTree;
